import React from "react";
import Calculation from "./Calculation";
import ConvertTime from "./convertTime";

const ApiOrderCard = ({
    index,
    element,
}) => {
    return (
        <div key={index}>
            <div className="overflow-hidden bg-white rounded-lg shadow-md border border-gray-100">
                {/* Header */}
                <div
                    className={`grid grid-cols-[1fr_auto_1fr] items-center
                        bg-gradient-to-r
                        ${element.currentState === "Started"
                            ? "from-violet-900 via-violet-600 to-fuchsia-500 pending-header"
                            : "from-violet-800 via-violet-700 to-purple-600"
                        }
                    text-white font-semibold px-3 py-2.5`}
                >
                    <div>
                        <div className="text-sm uppercase tracking-wide">KOT ID</div>
                        <div className="text-sm uppercase tracking-wide">{element.KOTID}</div>
                    </div>

                    <div className="text-center text-sm tracking-wide uppercase">
                        {element.orderType}
                    </div>
                </div>

                {/* Order Details */}
                <div className="bg-amber-50 border-b border-amber-100 px-2.5 py-2 text-center">
                    <div className="flex justify-between text-xs text-amber-800 font-medium mb-1 tracking-wide">
                        <ConvertTime timeOrder={element.orderTime} />
                        <span>Guests: {element.Guest_count}</span>
                    </div>

                    <div className="text-sm font-semibold uppercase tracking-wider text-amber-900">
                        {element.tableNum === "Take-Away"
                            ? "Take-Away"
                            : `Table ${element.tableNum}`}
                    </div>

                    <div className="text-sm font-medium text-amber-700 mt-0.5">{element.employee}</div>

                    <div className="mt-0.5 text-sm">
                        <Calculation Ordertime={element.orderTime} />
                    </div>
                </div>

                {/* Items */}
                <div className="divide-y divide-gray-100">
                    {element.OrderItemDetailsList.map((item, idx) => (
                        <div
                            key={idx}
                            className="grid grid-cols-[36px_1fr] items-center px-2.5 py-2 text-xs font-medium text-gray-800"
                        >
                            {/* Quantity */}
                            <div className="w-6 h-6 rounded-full bg-gray-100 text-gray-700 flex items-center justify-center text-xs font-bold">
                                {item.Quantity}
                            </div>

                            {/* Item Name */}
                            <div className="break-words text-xs leading-snug px-1">
                                {item.ItemName}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="p-2.5 bg-gray-50">
                    {element.currentState === "Started" ? (
                        <div
                            className="
                            w-full rounded-md
                            bg-violet-600 text-center
                            py-2 text-sm text-white uppercase
                            font-semibold tracking-widest
                            hover:bg-violet-700
                            active:scale-95 active:bg-violet-800
                            transition-all duration-150
                            seen-button
                        "
                        >
                            New Order
                        </div>
                    ) : (
                        <div
                            className="
                            w-full rounded-md
                            bg-emerald-600 text-center
                            py-2 text-sm text-white uppercase
                            font-semibold tracking-widest
                            cursor-default
                        "
                        >
                            In Preparation
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ApiOrderCard;
